import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { all, takeEvery, select, put } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { fetchNext, fetchPrevious, fetchAll, initializeIfNeeded } from './actions';
import { getStream, isInitialized, canStreamAutoFetch } from './selectors';
import { createCallbackActionCreator, getActionsForStreamType } from '../helpers';
function getFetchActionForDirection(actions, direction) {
    switch(direction){
        case 'all':
            return actions.fetchAll;
        case 'prev':
            return actions.fetchPrevious;
        case 'next':
        default:
            return actions.fetch;
    }
}
function getFetchActionForStreamType(type, direction) {
    const actions = getActionsForStreamType(type);
    const action = getFetchActionForDirection(actions, direction);
    if (!action) {
        ddt.warn('stream', 'Unknown stream type or action', type, direction);
        return (streamId)=>({
                streamId,
                type: 'STREAM__UNKNOWN_TYPE__FETCH'
            }); // no idea what this type is, noop
    }
    return action;
}
function* handleFetchNext({ payload: { streamId } }) {
    const stream = yield select(getStream, streamId);
    if (!stream || !stream.hasMore || stream.errorMsg || !stream.streamType) {
        return;
    }
    const fetchAction = getFetchActionForStreamType(stream.streamType, 'next');
    // kick off the reducers and any legacy handlers
    yield put(fetchAction(streamId));
    if (stream.fetchNextCallback) {
        yield put(createCallbackActionCreator(stream.fetchNextCallback)(streamId));
    }
}
function* handleFetchPrev({ payload: { streamId } }) {
    const stream = yield select(getStream, streamId);
    if (!stream || !stream.hasLess || stream.errorMsg || !stream.streamType) {
        return;
    }
    const fetchAction = getFetchActionForStreamType(stream.streamType, 'prev');
    // kick off the reducers and any legacy handlers
    yield put(fetchAction(streamId));
    if (stream.fetchPreviousCallback) {
        yield put(createCallbackActionCreator(stream.fetchPreviousCallback)(streamId));
    }
}
function* handleFetchAll({ payload: { streamId } }) {
    const stream = yield select(getStream, streamId);
    if (!stream || !(stream.hasMore || stream.hasLess) || stream.errorMsg || !stream.streamType) {
        return;
    }
    const fetchAction = getFetchActionForStreamType(stream.streamType, 'all');
    // kick off the reducers and any legacy handlers
    yield put(fetchAction(streamId));
    if (stream.fetchAllCallback) {
        yield put(createCallbackActionCreator(stream.fetchAllCallback)(streamId));
    }
}
function* handleInitIfNeeded(_param) {
    var { payload: { streamType, autoFetch } } = _param, initParams = _object_without_properties(_param.payload, [
        "streamType",
        "autoFetch"
    ]);
    const actions = getActionsForStreamType(streamType);
    const isInit = yield select(isInitialized, initParams.streamId);
    if (!isInit && actions.initialize) {
        yield put(actions.initialize(_object_spread({
            items: [],
            hasMore: true
        }, initParams)));
    }
    const canAutoFetch = yield select(canStreamAutoFetch, initParams.streamId);
    if (autoFetch && canAutoFetch) {
        yield put(fetchNext(initParams.streamId));
    }
}
export default function* baseStreamSaga(action) {
    yield all([
        takeEvery(fetchNext, handleFetchNext),
        takeEvery(fetchPrevious, handleFetchPrev),
        takeEvery(fetchAll, handleFetchAll),
        takeEvery(initializeIfNeeded, handleInitIfNeeded)
    ]);
}
